import React from 'react';
import PropTypes from 'prop-types';

import {
  DeviceDetails,
} from './styles';

const transformOsType = (os) => {
  if (!os || typeof os !== 'string') {
    return '';
  }
  switch (os.toLowerCase()) {
    case 'darwin':
      return 'Mac, ';
    case 'windows_nt':
      return 'Windows, ';
    case 'android':
      return 'Android ';
    case 'ios':
      return 'iOS ';
    default:
      return os;
  }
};

const DeviceInfo = (props) => {
  const { testSession } = props;
  const {
    deviceInfo,
    osType,
    osVersion,
  } = testSession;

  const {
    retailBrand,
    marketingName,
  } = deviceInfo || {};

  return (
    <DeviceDetails>
      {retailBrand}
      {retailBrand && ' '}
      {marketingName}
      {(retailBrand || marketingName) && ', '}
      {transformOsType(osType)}
      {osVersion}
    </DeviceDetails>
  );
};

DeviceInfo.defaultProps = {
  testSession: {},
};

DeviceInfo.propTypes = {
  testSession: PropTypes.shape({
    osType: PropTypes.string,
    osVersion: PropTypes.string,
    deviceInfo: PropTypes.shape({
      retailBrand: PropTypes.string,
      marketingName: PropTypes.string,
    }),
  }),
};

export default DeviceInfo;
